import { FileLogStatus } from "shared/types/file";

export interface DocumentLog {
  id?: string;
  documentDate?: string | Date | null;
  expirationDate?: string | Date | null;
  createdAt?: string | Date | null;
  status?: FileLogStatus | string;
  buildingId?: string;
  buildingName?: string;
  unitReferencePlus?: string;
  [extra: string]: unknown;
}

export type LabelLogsMap = Record<string, DocumentLog[]>;

export interface BuildingRow {
  id: string;
  address: string;
  labels: LabelLogsMap;
}

export interface UnitRow {
  id: string;
  referencePlus: string | null;
  buildingId: string | null;
  labels: LabelLogsMap;
}

export type ResourceRow = BuildingRow | UnitRow;

export interface RequiredLabels {
  buildings: Record<string, Record<string, boolean>>;
  units: Record<string, Record<string, boolean>>;
}

export interface LabelCount {
  available: number;
  total: number;
}

export type LabelCountMap = Record<string, LabelCount>;

export interface CellClickPayload {
  resource: ResourceRow;
  label: string;
  isBuilding: boolean;
}

export interface StatusFilterOption {
  key: string;
  label: string;
  colorClass: string;
}

export const AVAILABLE_STATUSES: StatusFilterOption[] = [
  { key: "ok", label: "Conform", colorClass: "bg-status-good" },
  {
    key: "expiring",
    label: "Verloopt binnenkort",
    colorClass: "bg-[#F59E0B]",
  },
  { key: "expired", label: "Verlopen", colorClass: "bg-brick-primary" },
  { key: "notOk", label: "Niet conform", colorClass: "bg-brick-primary" },
  {
    key: "missing",
    label: "Ontbreekt",
    colorClass: "border border-moss-primary",
  },
  {
    key: "notRequired",
    label: "Niet vereist",
    colorClass: "bg-neutral-secondary-mid",
  },
];

export const isLabelRequired = (
  required: Record<string, Record<string, boolean>> | undefined,
  resourceId: string,
  label: string,
): boolean => {
  if (!required || !resourceId) return true;
  const entry = required[resourceId];
  if (!entry) return true;
  if (!(label in entry)) return true;
  return entry[label] !== false;
};
